import {ShareDeviceFormState} from '@store/share-device-form/share-device-form.state';
import {Selector} from '@ngxs/store';
import {IResponse} from '@interfaces/response';
import {IDevice} from '@interfaces/devices';
import {ShareDeviceFormModel} from '@store/share-device-form/share-device-form.model';
import {ISharedDevicePhoto, ISingleSharedDevice} from '@interfaces/shared-devices';


export class ShareDeviceFormSelectors {
  @Selector([ShareDeviceFormState])
  static getDeviceToShare(state: ShareDeviceFormModel): IResponse<IDevice> | null {
    return state.deviceToShare.devices;
  }

  @Selector([ShareDeviceFormState])
  static getDeviceToSharePage(state: ShareDeviceFormModel): number {
    return state.deviceToShare.currentPage;
  }

  @Selector([ShareDeviceFormState])
  static getDevicesToShareItemPerPage(state: ShareDeviceFormModel): number {
    return state.deviceToShare.itemsPerPage;
  }

  @Selector([ShareDeviceFormState])
  static getDevicesToShareSearchValue(state: ShareDeviceFormModel): string {
    return state.deviceToShare.searchParam;
  }

  @Selector([ShareDeviceFormState])
  static getActiveDeviceIdToShare(state: ShareDeviceFormModel): number | null {
    return state.activeDeviceId;
  }

  @Selector([ShareDeviceFormState])
  static getDeviceToShareLoader(state: ShareDeviceFormModel): boolean {
    return state.deviceToShare.loader;
  }

  @Selector([ShareDeviceFormState])
  static getMaxSlidesNum(state: ShareDeviceFormModel): number {
    return state.maxSlidesNum;
  }

  @Selector([ShareDeviceFormState])
  static getSharedDevicesPhotos(state: ShareDeviceFormModel): ISharedDevicePhoto[] {
    return state.slidesPhotos;
  }

  @Selector([ShareDeviceFormState])
  static getActiveSharedDeviceName(state: ShareDeviceFormModel): string {
    return state.activeDeviceName;
  }

  @Selector([ShareDeviceFormState])
  static getActiveSharedDevice(state: ShareDeviceFormModel): ISingleSharedDevice | null {
    return state.activeDevice;
  }

  @Selector([ShareDeviceFormState])
  static isSliderLoader(state: ShareDeviceFormModel): boolean {
    return state.sliderLoader;
  }

  @Selector([ShareDeviceFormState])
  static getMapCoordinates(state: ShareDeviceFormModel): {lat: number | null, long: number | null, address: string} {
    return state.mapCoordinates;
  }
}
